import React from 'react';
import { SessionProvider, useSession } from '@battleops/client/src/context/SessionContext';
import Login from './pages/Login';
import AppRoutes from './AppRoutes';

// Gate: 'loading' → 'signedOut' | 'ready' ('expired' / 'noAccess' = back to the login screen, data kept).
function Gate() {
  const { status } = useSession();
  if (status === 'loading') return <div style={{ height: '100%', background: 'var(--c-bg)' }} />;
  if (status === 'signedOut' || status === 'expired' || status === 'noAccess') {
    return <Login expired={status === 'expired'} noAccess={status === 'noAccess'} />;
  }
  return <AppRoutes />;
}

export default function App() {
  return <SessionProvider><Gate /></SessionProvider>;
}
